<template>
<div class="row m-0 my-2 p-0 justify-content-start align-items-center">
	<pick-year-vidget
		v-model:year="currentYear"
		:is-request-active="isRequestActive"
	/>
</div>

<div class="row m-0">
	<div class="half-transparent-border widget-7x5 chart-widget">
		<station-lightnings-heatmap
			:station-id="stationId"
			:year="currentYear"
			@selected-day="onClickDay"
			@is-loading="(v) => isRequestActive = v"
		/>
	</div>
</div>

<div class="row m-0 mt-2">
	<lightnings-table
		:time-from="dayStart(selectedDay)"
		:time-to="dayEnd(selectedDay)"
		:station-ids="[stationId, ]"
		:in-modal="false"
		:empty-message="`
			${selectedDay == null
				? 'Б'
				: (chartDateStr(selectedDay) + ' Б')
			}лискавок не знайдено
		`"
	/>
</div>
</template>




<script>
import StationLightningsHeatmap from '@/components/Charts/StationLightningsHeatmap.vue'
import LightningsTable from "@/components/LightningsTable.vue"
import PickYearVidget from '@/components/Vidgets/PickYearVidget.vue'
import { INFLUXDB } from '@/api/api.js'
import {
	chartDateStr,
	dayStart,
	dayEnd,
} from '@/helpers.js'
import { Station } from '@/models/station.js'
import { ServiceUnit } from '@/models/serviceUnit.js'


export default {
	components: {
		StationLightningsHeatmap,
		LightningsTable,
		PickYearVidget,
	},


	props: {
		stationId: {
			type: String,
			require: true,
		},
	},


	setup() {
		return {
			INFLUXDB,
			dayStart,
			dayEnd,
			Station,
			ServiceUnit,
			chartDateStr,
		}
	},


	data() {
		return {
			currentYear: Number((new Date()).getFullYear()),
			selectedDay: new Date(),
			isRequestActive: true,
		}
	},


	async created() {},

	mounted() {},

	methods: {
		showPreviousDay() {
			const selectedDate = this.selectedDay == null ? new Date() : this.selectedDay
			this.selectedDay = new Date(selectedDate.getTime() - (24 * 3600 * 1000))
		},

		showNextDay() {
			const selectedDate = this.selectedDay == null ? new Date() : this.selectedDay
			this.selectedDay = new Date(selectedDate.getTime() + (24 * 3600 * 1000))
		},

		onClickDay(date) {
			// console.log('Click on day', date)
			this.selectedDay = date
		},
	},


	computed: {
		isSelectCurrentDay() {
			if (this.selectedDay == null) {
				return true
			}

			const selectedYear = this.selectedDay.getFullYear()
			const nowDate = new Date()
			const nowYear = nowDate.getFullYear()

			if (selectedYear != nowYear) {
				return false
			}

			const selectedDayOfYear = Math.floor(
				(this.selectedDay - new Date(selectedYear, 0, 0)) / (1000 * 60 * 60 * 24)
			)
			const nowDayOfYear = Math.floor(
				(nowDate - new Date(nowDate.getFullYear(), 0, 0)) / (1000 * 60 * 60 * 24)
			)

			return selectedDayOfYear == nowDayOfYear
		},
	},
}
</script>




<style src="@/assets/widget.css" scoped></style>
<style scoped>
	.input-min-width {
		min-width: 43ch; 
		max-width: 56ch;
		width: 100%;
	}

	.chart-widget {
		height: 260px; min-width: 600px;
	}

	.load-spinner {
		width: 7rem;
		height: 7rem;
	}
</style>